var map = {
	"./career_path_counseling.svg": 1798,
	"./create_resume.svg": 264,
	"./ethical_advice_decoration.svg": 4114,
	"./job_opportunities.svg": 8015,
	"./training_programs.svg": 5364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;